/**
 * Normalize a domain string for SFcore DomainAPI — strips scheme, leading www.,
 * path/query/hash, and lowercases.
 *
 * @param {string | null | undefined} value
 * @returns {string | null}
 */
export function normalizeDomainNameForApi(value) {
  if (value == null) return null;
  const trimmed = String(value).trim();
  if (!trimmed) return null;

  let domain = trimmed.toLowerCase();
  domain = domain.replace(/^https?:\/\//, "");
  domain = domain.replace(/^www\./, "");
  domain = domain.split(/[/?#]/)[0];
  domain = domain.replace(/\.$/, "");

  return domain || null;
}
